import { EventEmitter2 } from "eventemitter2";

/**
 * Abstract base class for all event-emitting classes
 * Provides event forwarding functionality and type-safe event emission
 */
export abstract class EventSource extends EventEmitter2 implements EventSourceInterface {
  constructor() {
    super({
      wildcard: true,
    });
  }

  /**
   * Forward all events from a source EventEmitter2 instance
   * Preserves the original event name and merges any additional context
   */
  protected forwardEvents(source: EventSourceInterface, context: Record<string, any> = {}): void {
    const self = this;
    source.on("**", function (data) {
      // @ts-ignore - event property is available in the wildcard listener context
      const eventName = this.event as string;
      // Forward the event with the same name and add context
      self.emit(eventName, { ...data, ...context });
    });
  }

  protected debug(message: string, data?: any) {
    if (process.env.NODE_ENV === "development") {
      console.log(message);
      if (data) {
        console.dir(data, { depth: null });
      }
    }
  }

  protected error(...args: any[]) {
    if (process.env.NODE_ENV === "development") {
      console.error(...args);
    }
  }
}

export interface EventSourceInterface {
  on(event: string, listener: (...args: any[]) => void): any;
}
